// https://www.cluemediator.com/detect-urls-in-a-text-and-convert-them-to-a-link-in-react#da for linkify
import { useMemo } from 'react'
// import {
//   // useParams,
//   // useNavigate,
// } from "react-router-dom"

import {
  useForm,
  UseFormProps,
  UseFormReturn,
  FormProvider,
} from "react-hook-form";

import {
  useQuery,
} from '@tanstack/react-query'

// import { yupResolver } from "@hookform/resolvers/yup";

import {  useAppStore } from '../store/appStore';

// import { validationSchema } from "../validation";
import { Typography, LinearProgress } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'

import { InitData, IAppForm, School, Subject, Grade, Ratio, Teacher, Place } from '../lib/interfaces/models'

import { StudentForm } from "./StudentForm";
import { Guardians } from "./Guardians";
import { Subjects } from './Subjects';
import { ConsentForm } from './ConsentForm';
import { CommentForm } from './CommentForm';
import { PrevForm } from './PrevForm';
import { FamilyForm } from './FamilyForm';
import { SnackFeedback } from '../components/SnackFeedback';


interface IRetData extends InitData {
  data: {
    nr: number
    code: string
    key: string

    school: School,
    subject: Subject[],
    grade: Grade[],
    ratio: Ratio[],
    teacher: Teacher[],
    place: Place[],
    oschool: School[],
    form: {
      year: number,
      gradeFlag: number,
      ratioFlag: number,
      mobileFlag: number,
      mobileText: string,
      oclass: number,
      oschool: number,
      sibling: number,
      teacherFlag: number,
      termsFlag: number,
      termsText: string,
      mediaFlag: number,
      mediaText: string
      emailFlag: number,
      emailText: string,
      elschoolFlag: number,
      elschoolText: string,
      extSubjFlag: number,
      extSubjText: string,
      familyFlag: number,
      familyText: string,
      familySubText: string,
      subjectMax: number,
      prevFlag: number
    },
    retapp: {
      status: number,
      anr: number
      time: string,
      year: number
      ssid: string
      name: string
      familyText?: string
      oschool?: number
      oschoolclass?: number
      prev?: number
      prevText?: string
      media?: number | null
      mediaQuestion?: string
      terms?: number
      termsQuestion?: string
      email?: number
      emailQuestion?: string
      comment?: string
      xsubject?: string
      email1?: string
      email2?: string
      email3?: string
      tel1?: string
      tel2?: string
      tel3?: string
    }
  }
}

////////////////////////////////////
export const RAppForm = () => {

  // const navigate = useNavigate()

  // const linkifyOptions = {
  //   target: '_blank',
  //   style: { color: '#ff0000' },
  // }

  // const hideSubmit = useAppStore(state => state.hideSubmit)
  // const setApiReturn = useAppStore(state => state.setApiReturn)
  // const setSnackText = useAppStore(state => state.setSnackText)

  // const setReturnKeys = useAppStore(state => state.setReturnKeys)
  const returnKeys = useAppStore(state => state.returnKeys)


  const { nr, code, key } = returnKeys
  const { data } = useQuery<IRetData>({ queryKey: [`/appform3/${nr}/${code}/${key}`] })

  const apiData = data?.data
  const masterTermsFlag = apiData?.form.emailFlag || apiData?.form.termsFlag || apiData?.form.mediaFlag

  const retData = { ...apiData?.retapp, 
    // media: apiData?.retapp.media === 1 ? true : false,
    terms: apiData?.retapp.terms === 1 ? true : false,
    email: apiData?.retapp.email === 1 ? true : false,
  }
  // console.log("retData:", retData)


  // filter only the saved selected option
  const _oschoolOptions = apiData?.oschool.map(option => {
    return { title: option.name, value: option.nr }
  })
  const oSchoolOptions = _oschoolOptions?.filter(option => {
    return option.value === retData.oschool
  })

  const oSchoolClass = [
    { title: "1. bekkur", value: 1 },
    { title: "2. bekkur", value: 2 },
    { title: "3. bekkur", value: 3 },
    { title: "4. bekkur", value: 4 },
    { title: "5. bekkur", value: 5 },
    { title: "6. bekkur", value: 6 },
    { title: "7. bekkur", value: 7 },
    { title: "8. bekkur", value: 8 },
    { title: "9. bekkur", value: 9 },
    { title: "10. bekkur", value: 10 },
    { title: "Á ekki við", value: 0 },
  ]

  const oSchoolClassOptions = oSchoolClass.filter(cla =>(
    cla.value === retData.oschoolclass
  ))


  // const oSchoolOptions = apiData?.oschool.map(option => {
  //   return { title: option.name, value: option.nr }
  // })

  // const getScYear = () => {
  //   return apiData?.form.year
  // }

  // const mutation = useMutation({
  //   mutationFn: (formData: IAppForm) => {
  //     return axios.post('https://tonviska.is/api/v1/appform', formData)
  //   }
  // })




  const defaultValues = {

    terms: false,
    email: false,
    ssid: '',
    name: '',
    email1: '',
    email2: '',
    email3: '',
    tel1: '',
    tel2: '',
    tel3: '',
    oschool: '',
    oschoolclass: '',
    prev: '',
    subjects: [
      { id: '', teacherid: '', rateid: '', gradeid: '' },
    ]
  }

  // const testvalues = {
  //   // oschool 41

  //   media: true,
  //   terms: true,
  //   email: true,
  //   ssid: '2007573949',
  //   name: 'Gunnar Smári Helgason',
  //   tel1: '8948421',
  //   email1: 'gsmari@gmail.com',
  //   email2: 'viska@viska.is',
  //   oschool: 41,
  //   oschoolclass: 2,
  //   subjects: [
  //     { 'id': 72 },
  //   ]

  // }



  const form: UseFormReturn<IAppForm, UseFormProps> = useForm<IAppForm>({
    // mode: "all",
    // mode: "onBlur",
    // mode: "onChange",
    mode: "onTouched",
    defaultValues,
    // resolver: yupResolver(validationSchema),
  });

  useMemo(()=>{
    form.reset(retData)
  },[apiData])


  return (
    <>
      {/* <button onClick={()=>doTest()}>test</button> */}
      <FormProvider {...form}>
        <div>

          <Grid container sx={{ pt: 1, backgroundColor: '#FAFAFA' }}>
            <Grid xs={12}>
              <Typography variant='h5' align="center">{apiData?.school.name}</Typography>
            </Grid>
            {apiData?.school.open && apiData?.school.name
              ?
              <>
                <Grid xs={12}>
                  <Typography variant="h6" align="center">
                    {retData?.anr && `Umsókn nr: ${retData?.anr} móttekin`}
                    </Typography>
                  <Typography variant="h6" align="center">{apiData?.form.year} - {apiData?.form.year + 1}</Typography>
                </Grid>

                <Grid xs={12}>
                  <StudentForm
                    oSchoolOptions={oSchoolOptions || [{ title: "", value: 0 }]}
                    oSchoolClassOptions={oSchoolClassOptions || [{ title: "", value: 0 }]}
                    oschool={apiData.form.oschool}
                    oclass={apiData.form.oclass}
                    readonly={true}
                    />
                </Grid>

                <Grid xs={12}>
                  <Guardians readonly={true} />

                  {apiData.form.familyFlag === 1 && <Grid xs={12}>
                    <FamilyForm
                      title={apiData.form.familyText}
                      subtitle={apiData.form.familySubText}
                      schoolName3={apiData.school.name3}
                      readonly={true}
                    />
                  </Grid>}

                  {apiData.form.prevFlag === 1 && <Grid xs={12}>
                    <PrevForm
                      title='Fyrra tónlistarnám'
                      schoolName3={apiData.school.name3}
                      readonly={true}
                    />
                  </Grid>}
                </Grid>


                <Grid xs={12}>
                  <Subjects
                    options={apiData.subject}
                    teacherOptions={apiData.teacher}
                    teacherFlag={apiData.form.teacherFlag}
                    placeOptions={apiData.place}
                    gradeOptions={apiData.grade}
                    ratioOptions={apiData.ratio}
                    subjectMax={apiData.form.subjectMax}
                  />
                </Grid>

                {apiData.form.extSubjFlag === 1 && <Grid xs={12}>
                  <CommentForm
                    title={apiData.form.extSubjText}
                    name="xsubject" 
                    readonly={true}
                  />
                </Grid>}

                {masterTermsFlag === 1 && <Grid xs={12}>
                  <ConsentForm
                    title='Skilmálar'
                    text={apiData.form.termsText}
                    name={apiData.form.termsFlag === 1 ? "terms" : ""}
                    text2={apiData.form.mediaText}
                    name2={apiData.form.mediaFlag === 1 ? "media" : ""}
                    text3={apiData.form.emailText}
                    name3={apiData.form.emailFlag === 1 ? "email" : ""}
                    text4={apiData.form.elschoolText}
                    name4={apiData.form.elschoolFlag === 1 ? "elschool" : ""}
                    text5={apiData.form.mobileText}
                    name5={apiData.form.mobileFlag === 1 ? "mobile" : ""}
                    readonly={true}
                  />
                </Grid>}

                <Grid xs={12}>
                  <CommentForm
                    title='Annað sem þú vilt taka fram'
                    subtitle="T.d. tónlistarmenntun, reynsla í tónlist eða annað sem gæti skipt máli"
                    name="comment"
                    readonly={true}
                  />
                </Grid>


                {/* <Button type="submit" variant="outlined" fullWidth>
                  Senda inn umsókn
                </Button> */}
              </>
              :
              <Grid xs={12} sx={{mt: 8}}>
                <Typography variant="h4" align="center">
                  <LinearProgress />
                </Typography>
              </Grid>
            }
          </Grid>
          <br />
          <br />


          {/* <input type="hidden" defaultValue={c} {...form.register("code")} />
          <input type="hidden" defaultValue={s} {...form.register("scNr")} /> */}
        </div>
      </FormProvider>
      <SnackFeedback />
    </>
  );
};

export default RAppForm;
